import { useMutation } from '@tanstack/react-query';
import { queryClient } from '@/queries';
import { QUERY_KEYS } from '@/lib/constants';
import {
    applyFreeMonthOffer,
    type ApplyOfferPayload,
    applyTwoMonthDiscountOffer,
    cancelPlatformSubscription,
} from '@/lib/api/settings/cancellation';

export const useApplyFreeMonthOffer = () => {
    const { mutateAsync, isPending } = useMutation({
        mutationFn: (data: ApplyOfferPayload) => applyFreeMonthOffer(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER] });
        },
    });

    return { mutateAsync, isPending };
};

export const useApplyTwoMonthDiscountOffer = () => {
    const { mutateAsync, isPending } = useMutation({
        mutationFn: (data: ApplyOfferPayload) => applyTwoMonthDiscountOffer(data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER] });
        },
    });

    return { mutateAsync, isPending };
};

export const useCancelPlatformSubscription = () => {
    const { mutateAsync, isPending, isError } = useMutation({
        mutationFn: (subscriptionId: string) => cancelPlatformSubscription(subscriptionId),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.USER] });
        },
    });

    return { mutateAsync, isPending, isError };
};
